import React, { useEffect } from 'react';
import { sample } from 'lodash';

import { Tile } from '../components';
import { canSeeShortlist, login_url } from '../globals'
import { useLogin, useThread } from '../reducers'
import { get_problemi_buoni } from '../utils';


const Home = (props: {}) => {
  const login = useLogin();
  useEffect(() => {
    document.title = `Owlitrack`;
  }, [])
  if (!login.logged_in) {
    login_url()
  }

  let shortlist;
  if (canSeeShortlist(login.user)) {
    shortlist = <div className="mt-2">
      <h2>Shortlists</h2>
      <div className="d-flex flex-wrap align-content-between flex-fill">
        <Tile
          url={`/shortlist/`}
          text="Shortlists"
          color="wet-asphalt" icon="fa fa-list"
          size="tile-wide"
        />
      </div>
    </div>
      ;
  }

  const thread = useThread(props);

  const { id } = login.user;

  // Problemi non finiti in gara e non da sistemare/evitare
  const problemi_buoni = get_problemi_buoni(thread)

  // Problemi che l'utente non ha ancora fatto
  const problemi_non_risolti = problemi_buoni.filter(item => !item.problema.correttori_eseguito.includes(id))

  // Problemi da validare
  const problemi_da_risolvere = problemi_non_risolti.filter(item => item.problema.correttori_eseguito.length < 3)

  // Se possibile un problema da validare, altrimenti uno qualsiasi non risolto dall'utente
  const problema_random = sample(problemi_da_risolvere.length ? problemi_da_risolvere : problemi_non_risolti)

  return (
    <div className="container">
      <h1 className="page-header">Owlitrack homepage</h1>
      <h2>Thread per i problemi</h2>
      <div className="d-flex flex-wrap align-content-between flex-fill">
        <Tile
          url={`/thread/problema/miei/`}
          text="I problemi proposti da me"
          color="secondary" icon="fa fa-piggy-bank"
          size="tile-wide"
        />
        <Tile
          url={`/thread/problema/assegnati/`}
          text="I problemi che mi hanno assegnato"
          color="primary" icon="fa fa-clipboard-list"
          size="tile-wide"
        />
        <Tile
          url={`/thread/problema/`}
          text="Tutti i problemi"
          color="teal" icon="fa fa-list-ul"
          size="tile-wide"
        />
        <Tile
          url={`/thread/problema/new/`}
          text="Proponi un problema"
          color="success" icon="fa fa-plus"
          size="tile-wide"
        />
        <Tile
          url={`/utente/`}
          text="Tutti gli utenti"
          color="amethys" icon="fa fa-address-book"
          size="tile-wide"
        />
        {problema_random &&
          <Tile
            url={`/thread/problema/${problema_random.id}/`}
            text="Problema random"
            color="danger" icon="fa fa-dice"
            size="tile-wide"
          />
        }
        {!problema_random &&
          <Tile
            url={`/`}
            text="Nessun problema da risolvere"
            color="secondary" icon="fa fa-dice"
            size="tile-wide"
          />
        }
        <Tile
          url={`/drafts/`}
          text="Bozze"
          color="info" icon="fa fa-cogs"
          size="tile-wide"
        />
        <Tile
          url={`/top-contributors/`}
          text="Top contributors"
          color="sunflower" icon="fa fa-trophy"
          size="tile-wide"
        />
        <Tile
          url={`/last-news/`}
          text="Ultimi avvenimenti"
          color="pumpkin" icon="fa fa-newspaper"
          size="tile-wide"
        />
      </div>
      {shortlist}
    </div>
  )
}

export default Home;
